var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "communityConfig" }, [
    _c(
      "div",
      { staticClass: "width-75" },
      [
        _c(
          "Form",
          {
            ref: "project",
            attrs: {
              model: _vm.project,
              rules: _vm.ruleValidate,
              "label-width": 150,
              "label-colon": "",
            },
          },
          [
            _c(
              "FormItem",
              { attrs: { prop: "name", label: _vm.$t("check.projectName") } },
              [
                _c("Input", {
                  attrs: {
                    placeholder: _vm.$t("check.projectNameTip"),
                    size: "large",
                    maxlength: "50",
                    clearable: "",
                  },
                  model: {
                    value: _vm.project.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.project, "name", $$v)
                    },
                    expression: "project.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormItem",
              {
                attrs: { prop: "description", label: _vm.$t("check.describe") },
              },
              [
                _c("Input", {
                  attrs: {
                    type: "textarea",
                    autosize: { minRows: 4, maxRows: 6 },
                    placeholder: _vm.$t("check.contentTip"),
                    size: "large",
                    clearable: "",
                    maxlength: "1024",
                  },
                  model: {
                    value: _vm.project.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.project, "description", $$v)
                    },
                    expression: "project.description",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormItem",
              {
                attrs: { prop: "areaCodeNum", label: _vm.$t("check.areaType") },
              },
              [
                _c(
                  "Select",
                  {
                    staticClass: "select-box",
                    attrs: {
                      size: "large",
                      disabled: _vm.areaDeviceData.length > 0,
                      title:
                        _vm.areaDeviceData.length > 0
                          ? _vm.$t("updateNewSip.communityTip")
                          : "",
                    },
                    on: { "on-open-change": _vm.setAreaCode },
                    model: {
                      value: _vm.project.areaCodeNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "areaCodeNum", $$v)
                      },
                      expression: "project.areaCodeNum",
                    },
                  },
                  _vm._l(5, function (i) {
                    return _c("Option", { key: i, attrs: { value: i } }, [
                      _vm._v(_vm._s(i)),
                    ])
                  }),
                  1
                ),
                _c(
                  "span",
                  { staticClass: "area-tip" },
                  [
                    _c("Icon", {
                      staticClass: "tip-icon",
                      attrs: { type: "md-help-circle" },
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("check.example")) + " "),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("FormItem", { attrs: { prop: "areaCodeDescription" } }, [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _c("span", { staticClass: "error-color" }, [_vm._v("*")]),
                _vm._v(
                  " " + _vm._s(_vm.$t("updateNewSip.areaNameTitle")) + " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "flex-box" },
                [
                  _vm.project.areaCodeNum >= 1
                    ? _c("Input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 3 },
                          placeholder: _vm.$t("check.areaNameTip"),
                          size: "large",
                          maxlength: "20",
                          clearable: "",
                        },
                        model: {
                          value: _vm.areaCodeDescription1,
                          callback: function ($$v) {
                            _vm.areaCodeDescription1 = $$v
                          },
                          expression: "areaCodeDescription1",
                        },
                      })
                    : _vm._e(),
                  _vm.project.areaCodeNum >= 2
                    ? _c("Input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 3 },
                          placeholder: _vm.$t("check.areaNameTip"),
                          size: "large",
                          maxlength: "20",
                          clearable: "",
                        },
                        model: {
                          value: _vm.areaCodeDescription2,
                          callback: function ($$v) {
                            _vm.areaCodeDescription2 = $$v
                          },
                          expression: "areaCodeDescription2",
                        },
                      })
                    : _vm._e(),
                  _vm.project.areaCodeNum >= 3
                    ? _c("Input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 3 },
                          placeholder: _vm.$t("check.areaNameTip"),
                          size: "large",
                          maxlength: "20",
                          clearable: "",
                        },
                        model: {
                          value: _vm.areaCodeDescription3,
                          callback: function ($$v) {
                            _vm.areaCodeDescription3 = $$v
                          },
                          expression: "areaCodeDescription3",
                        },
                      })
                    : _vm._e(),
                  _vm.project.areaCodeNum >= 4
                    ? _c("Input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 3 },
                          placeholder: _vm.$t("check.areaNameTip"),
                          size: "large",
                          maxlength: "20",
                          clearable: "",
                        },
                        model: {
                          value: _vm.areaCodeDescription4,
                          callback: function ($$v) {
                            _vm.areaCodeDescription4 = $$v
                          },
                          expression: "areaCodeDescription4",
                        },
                      })
                    : _vm._e(),
                  _vm.project.areaCodeNum >= 5
                    ? _c("Input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 3 },
                          placeholder: _vm.$t("check.areaNameTip"),
                          size: "large",
                          maxlength: "20",
                          clearable: "",
                        },
                        model: {
                          value: _vm.areaCodeDescription5,
                          callback: function ($$v) {
                            _vm.areaCodeDescription5 = $$v
                          },
                          expression: "areaCodeDescription5",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-box center-box" },
          [
            _c(
              "Button",
              {
                staticClass: "footer-btn",
                attrs: { type: "primary", ghost: "", size: "large" },
                on: { click: _vm.showImportModal },
              },
              [_vm._v(" " + _vm._s(_vm.$t("deviceSip.importAddr")) + " ")]
            ),
            _c(
              "Button",
              {
                staticClass: "footer-btn",
                attrs: { type: "primary", size: "large" },
                on: {
                  click: function ($event) {
                    return _vm.setCurrentStep(1)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("deviceSip.next")) + " ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content_win" },
      [
        _c("importModal", {
          ref: "importModal",
          on: { updateTree: _vm.updateTree },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }